/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delivered-package': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10.992 15.162l4.032-3.05a.56.56 0 01.892.385.57.57 0 01-.22.52l-4.48 3.388a.558.558 0 01-.784-.113l-1.68-2.26a.566.566 0 01.381-.899.557.557 0 01.515.222l1.344 1.807zm9.408-7.68v12.424a1.69 1.69 0 01-1.68 1.694H5.28a1.69 1.69 0 01-1.68-1.694V7.482c0-.007.004-.014.004-.022a.592.592 0 01.035-.172c.004-.012.007-.025.013-.037l.007-.021 1.93-3.894A1.672 1.672 0 017.092 2.4h9.816a1.668 1.668 0 011.502.936l1.93 3.894c.004.007.005.014.008.021.006.012.009.025.013.037.02.055.032.113.035.172 0 .008.004.015.004.022zM16.908 3.53h-4.306v3.389h6.202l-1.525-3.076a.56.56 0 00-.501-.313h.13zM5.153 6.918h6.237V3.529H7.178a.555.555 0 00-.5.313L5.153 6.918zM19.2 8.258H4.8v11.455c0 .301.248.545.554.546h13.292a.55.55 0 00.554-.546V8.26z"/>'
  }
})
